
    var riot = require('riot')
    
riot.tag2('artists-minilist', '<div class="dynamicList dl_artists {carousel ? \'owl-carousel\' : \'minilist\'}"> <div if="{carousel}" class="item browseall"> <div class="content"> <h3>Get Inspired</h3> <hr><a href="/artists/" class="btn btn-default btn-lg">Browse All Artists</a> </div> </div> <div each="{artist in artists}" class="item {!carousel ? \'col-xs-12 col-sm-6 col-md-3\' : \'\'}"><a href="/artists/profile/?id={artist.id}"><img riot-tag="img_loader" riot-src="/images/user-images/user{artist.id}-profile1.jpg/rs-450x300c.jpg" default="/images/assets/dlist-default.png/rs-450x300c.png" width="100%" alt="{artist.first_name} {artist.surname}" title="{artist.first_name} {artist.surname}"></a> <div if="{carousel}" class="textblock"> <h3><a href="/artists/profile/?id={artist.id}">{artist.first_name} {artist.surname}</a></h3> <hr class="hrleft"> <div> <p if="{artist.locale || artist.country}"><i class="fa fa-map-marker"></i>&nbsp;<span if="{artist.locale}">{artist.locale}, </span><span if="{artist.country}">{artist.country}</span><br><i class="fa fa-paint-brush"></i><span if="{artist.sashort}">&nbsp;<span riot-tag="raw" content="{artist.sashort}">{artist.sashort}</span></span></p> </div> </div> </div> </div>', '.minilist > .item > img { -webkit-box-shadow: 0 0 1px rgba(0,0,0,0.1); box-shadow: 0 0 1px rgba(0,0,0,0.1); }', '', function(opts) {
var api, resource;

resource = require('riot-kit/utils/apiResource.coffee');

api = new resource('/duocms/api/artists', true);

this.artists = null;

this.subjopts = {
  "3D modelling and rendering": 0,
  "3D models": 0,
  "anatomy and pathology": 0,
  "animations": 0,
  "biology and histology": 0,
  "clinical and diagnostic imaging": 0,
  "graphic design and publishing": 0,
  "infographics": 0,
  "legal and forensic": 0,
  "plastic and reconstruction": 0,
  "sculpture and installations": 0,
  "sport and physiotherapy": 0,
  "surgical steps": 0,
  "traditional painting": 0,
  "video and multimedia": 0
};

this.busopts = {
  "Advertising": 0,
  "Art & Exhibitions": 0,
  "Biotechnology": 0,
  "Marketing & Communications": 0,
  "Medical devices": 0,
  "Medical education": 0,
  "Pharmaceutical": 0,
  "Publishing": 0,
  "Teaching": 0
};

this.carousel = this.opts.carousel || null;

this.on('mount', (function(_this) {
  return function() {
    api.get(function(data) {
      return _this.onload(data);
    });
    return _this.update();
  };
})(this));

this.onload = (function(_this) {
  return function(data) {
    _this.artists = _this.shuffle(data);
    _this.artists.map(function(artist) {
      var ba, sa;
      artist.locale = artist.city || artist.state || false;
      sa = _this.checkJson(artist.subjectareas) || _this.subjopts;
      ba = _this.checkJson(artist.businessareas) || _this.busopts;
      artist.sashort = _this.shortString(sa);
      artist.bashort = _this.shortString(ba);
      return artist;
    });
    if (_this.opts.limit) {
      _this.artists = _this.artists.splice(0, _this.opts.limit);
    }
    _this.update();
    return setTimeout(function() {
      return $(document).ready(function() {
        return $('.dl_artists.owl-carousel').owlCarousel({
          items: 3,
          pagination: true,
          nav: true,
          margin: 15,
          navContainer: '#artists-nav',
          responsive: {
            0: {
              items: 1
            },
            992: {
              items: 3
            }
          }
        });
      });
    }, 1000);
  };
})(this);

this.checkJson = (function(_this) {
  return function(obj) {
    if (obj !== null && (obj.constructor !== {}.constructor)) {
      obj = JSON.parse(obj);
    }
    return obj;
  };
})(this);

this.shortString = (function(_this) {
  return function(obj) {
    var newkeys, rndkey, str;
    str = '';
    newkeys = [];
    Object.keys(obj).forEach(function(key) {
      if (obj[key] > 0) {
        return newkeys.push(key);
      }
    });
    if (newkeys.length > 0) {
      rndkey = newkeys[newkeys.length * Math.random() << 0];
      str += rndkey;
      if (newkeys.length > 1) {
        str += ' <small><em>(+' + (newkeys.length - 1) + ' more)</em></small>';
      }
    }
    return str;
  };
})(this);

this.shuffle = function(array) {
  var currentIndex, randomIndex, temporaryValue;
  currentIndex = array.length;
  temporaryValue = void 0;
  randomIndex = void 0;
  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
};
});


riot.tag2('artists-list', '<div class="container"> <div class="row"> <div class="col-xs-12"> <div class="artist-filters form-inline"> <div class="form-group"> <div class="input-group"><span class="input-group-addon"><i class="fa fa-search"></i></span> <input id="artistsearchtext" type="text" placeholder="Artists search..." onkeyup="{filterartists.bind(this,\'searchtext\')}" class="form-control"> </div> </div> <div class="form-group"> <div class="table"> <dropdown><a href="#" role="button" onclick="{toggle}">{parent.subjddtext}</a> <ul class="dropdown-menu"> <li><a onclick="{parent.filterartists.bind(this,\'subject\',false)}">All</a></li> <li each="{sa,index in parent.subjopts}"><a onclick="{parent.parent.filterartists.bind(this,\'subject\',sa)}">{sa}</a></li> </ul><i class="fa fa-angle-down"></i> </dropdown> <dropdown><a href="#" role="button" onclick="{toggle}">{parent.sectddtext}</a> <ul class="dropdown-menu"> <li><a onclick="{parent.filterartists.bind(this,\'sector\',false)}">All</a></li> <li each="{ba,index in parent.busopts}"><a onclick="{parent.parent.filterartists.bind(this,\'sector\',ba)}">{ba}</a></li> </ul><i class="fa fa-angle-down"></i> </dropdown> <dropdown><a href="#" role="button" onclick="{toggle}">{parent.ctryddtext}</a> <ul class="dropdown-menu"> <li><a onclick="{parent.filterartists.bind(this,\'country\',false)}">All</a></li> <li each="{country in parent.countries}"><a onclick="{parent.parent.filterartists.bind(this,\'country\',country)}">{country}</a></li> </ul><i class="fa fa-angle-down"></i> </dropdown> </div> </div> </div> <div class="pull-right"> <div class="btn-group listbuttons"> <button onclick="{showgridview}" class="btn-default {listview ? \'\' : \'active\'}"><i class="fa fa-th"></i>Grid View</button> <button onclick="{showlistview}" class="btn-default {listview ? \'active\' : \'\'}"><i class="fa fa-list"></i>List View</button> </div> </div> <p if="{!chosencountry &amp;&amp; !chosensector &amp;&amp; !chosensubject}">&nbsp;</p> <p if="{chosencountry || chosensector || chosensubject}"><span if="{chosencountry}" class="filterlink">{chosencountry}<a onclick="{removeFilter.bind(this,\'country\')}" class="fa fa-times"></a></span><span if="{chosensector}" class="filterlink">{chosensector}<a onclick="{removeFilter.bind(this,\'sector\')}" class="fa fa-times"></a></span><span if="{chosensubject}" class="filterlink">{chosensubject}<a onclick="{removeFilter.bind(this,\'subject\')}" class="fa fa-times"></a></span></p> <hr class="hrleft"> <div class="dynamicList dl_artists dl_artists_grid {listview ? \'listview\' : \'\'}"> <div each="{artist,i in page}" riot-tag="artist-modal" aid="{artist.id}" artist="{artist}" data-sa="{artist.sastring}" data-ba="{artist.bustring}" data-country="{artist.country}" uid="{userid}" isadmin="{isadmin}" unpublished="{artist.active &lt; 1 ? \'true\' : \'false\'}" class="item col-xs-12 col-md-4"><a onclick="{popup}" class="imgbox"> <div class="ratio"></div> <div riot-style="background-image:url(\'/images/user-images/user{artist.id}-profile1.jpg\');" class="img"></div></a> <div class="textblock"> <h3><a href="{artist.path}" onclick="{popup}">{artist.first_name} {artist.surname}</a></h3> <hr class="hrleft"> <div class="details"> <p><i class="fa fa-map-marker"></i>&nbsp;<span if="{artist.locale}">{artist.locale}, </span><span if="{artist.country}">{artist.country}</span><br><i class="fa fa-paint-brush"></i><span if="{artist.sashort}">&nbsp;<span riot-tag="raw" content="{artist.sashort}">{artist.sashort}</span></span></p> </div> <div if="{artist.expiry &amp;&amp; isadmin}" class="expired"> <div class="fa fa-warning"></div> Membership expired <strong>{artist.expiry}</strong> </div> <div if="{!artist.public &amp;&amp; !artist.expiry &amp;&amp; isadmin}" class="notpublic"> <div class="fa fa-info-circle"></div> Active Member - not public </div> </div> </div> </div> <div if="{!initload}" class="alert-danger alert-padded {filtered.length == 0 ? \'showme\' : \'\'}">Sorry, your search did not return any results. <a onclick="{resetfilters}">Click here to reset all filters</a></div> <pagination perpage="6" data="{filtered}" max="6" updatepages="{handlePage}"></pagination> <hr> </div> </div> </div>', '.expired, .notpublic { font-size: 12px; font-size: 1.2rem; color: #fff; background: #fc2d21; position: absolute; bottom: 0; width: 100%; left: 0; padding: 3px 10px; } .expired.notpublic, .notpublic.notpublic { background: #09ad16; } .listview .expired, .listview .notpublic { position: relative; } .alert-padded { padding: 15px; font-size: 20px; font-size: 2rem; margin-bottom: 30px; border: 1px solid #fc2d21; background: rgab(#fc2d21, 0.05); border-radius: 5px; color: #fc2d21; display: none; opacity: 0; -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; filter: alpha(opacity=0); } .alert-padded.showme { display: block; opacity: 1; -ms-filter: none; filter: none; } .alert-padded a { cursor: pointer; } .filterlink { background: rgba(252,45,33,0.05); border: 1px solid #fc2d21; border-radius: 15px; height: 30px; line-height: 28px; font-size: 15px; padding: 0 10px; display: inline-block; margin-right: 10px; } .filterlink a.fa { display: inline-block; margin-left: 10px; text-decoration: none; cursor: pointer; } .listbuttons button { border: 0px solid transparent; outline: 0px solid transparent; font-size: 12px; } .listbuttons button i.fa { font-size: 22px; display: block; } .listbuttons .active { color: #f00 !important; background: transparent; } artists-list { display: block; } artists-list .countries-table { width: 100vw; bottom: 0; background: #fff; } artists-list .countries-table .table { display: block; text-align: center; margin: 0; } artists-list .countries-table .table .td { display: inline-block; text-align: center; } artists-list .countries-table .table .td h4 { font-size: 24px; font-size: 2.4rem; padding: 0 15px; line-height: 200%; } artists-list .countries-table .table .td h4:hover { background: #fc2d21; color: #fff; cursor: pointer; } artists-list .countries-table .table .td h4.active { background: #e9e9e9; } artists-list .artist-filters { width: 100%; margin-bottom: 30px; background: #fff; -webkit-box-shadow: 0 15px 15px rgba(0,0,0,0.1); box-shadow: 0 15px 15px rgba(0,0,0,0.1); display: table; position: relative; z-index: 10000; } artists-list .artist-filters .form-group { display: table-cell; } artists-list .artist-filters .form-group:first-child { width: 25%; } artists-list .artist-filters .form-group:last-child { width: 75%; } artists-list .artist-filters .form-group .table { margin: 0; } artists-list .artist-filters .form-group .table dropdown { float: left; width: calc(100% / 3); z-index: 2; } artists-list .artist-filters .form-group .table dropdown.open { z-index: 3; } artists-list .artist-filters .form-group .table dropdown a { display: block; text-decoration: none; color: #44565e; padding: 18px 30px; } artists-list .artist-filters .form-group .table dropdown i.fa { position: absolute; right: 15px; font-size: 30px; width: 30px; height: 30px; top: 50%; margin-top: -15px; pointer-events: none; } artists-list .artist-filters .form-group .table dropdown:first-child, artists-list .artist-filters .form-group .table dropdown:nth-child(2) { border-right: 1px solid #ccc; } artists-list .artist-filters .form-group .table dropdown ul { width: 100%; } artists-list .artist-filters .form-group .table dropdown ul a { padding: 5px 10px; cursor: pointer; } artists-list .artist-filters .form-group .input-group { width: 100%; } artists-list .artist-filters .form-group input { border-radius: 0; background: transparent; -webkit-box-shadow: none; box-shadow: none; padding: 30px; border-color: #ccc; border-top: 0px solid transparent; border-left: 0px solid transparent; border-bottom: 0px solid transparent; } artists-list .artist-filters .form-group .input-group-addon { padding-right: 0; border: 0px solid transparent; background: transparent; } artists-list .artist-filters .form-group .btn-submit { background: #303030; color: #fff; font-size: 18px; padding: 17px; } @media (max-width: 991px) { artists-list .artist-filters .form-group { display: block; width: auto !important; } artists-list .artist-filters .form-group .table dropdown { float: none; width: auto; } } artists-list .dl_artists .item[unpublished="true"] { opacity: 0.5; -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=50)"; filter: alpha(opacity=50); } artists-list .dl_artists .item .details { font-size: 16px; } artists-list .dl_artists .item .details i.fa { display: inline-block; width: 20px; } artists-list .dl_artists .item .details span { font-size: 15px; } artists-list .dl_artists .item .imgbox { display: block; position: relative; } artists-list .dl_artists .item .imgbox .ratio { width: 100%; height: 0; padding-bottom: 66.6666666%; background-image: url("/images/assets/dlist-default.png"); background-repeat: no-repeat; background-position: center center; background-size: cover; } artists-list .dl_artists .item .imgbox .img { position: absolute; top: 0; left: 0; right: 0; bottom: 0; width: 100%; height: 100%; background-position: center; background-repeat: no-repeat; background-size: cover; } artists-list .listview:before, artists-list .listview:after { display: none !important; } artists-list .listview .item { width: auto; display: block; float: none; margin-bottom: 30px !important; } artists-list .listview .item .imgbox, artists-list .listview .item hr { display: none; } artists-list .listview .item .textblock { margin: 0; padding: 0; background: transparent; -webkit-box-shadow: none; box-shadow: none; border-bottom: 1px solid rgba(0,0,0,0.1); } artists-list .listview .item .textblock h3 { font-size: 24px; } @media (min-width: 992px) { .listview { display: grid; grid-template-columns: repeat(2, 1fr); } } @media (min-width: 1200px) { .listview { grid-template-columns: repeat(3, 1fr); } }', '', function(opts) {
var api, resource;

require('smoothscroll-polyfill').polyfill();

this.moment = require('moment');

resource = require('riot-kit/utils/apiResource.coffee');

api = new resource('/duocms/api/artists', true);

this.subjopts = {
  "3D modelling and rendering": 0,
  "3D models": 0,
  "anatomy and pathology": 0,
  "animations": 0,
  "biology and histology": 0,
  "clinical and diagnostic imaging": 0,
  "graphic design and publishing": 0,
  "infographics": 0,
  "legal and forensic": 0,
  "plastic and reconstruction": 0,
  "sculpture and installations": 0,
  "sport and physiotherapy": 0,
  "surgical steps": 0,
  "traditional painting": 0,
  "video and multimedia": 0
};

this.busopts = {
  "Advertising": 0,
  "Art & Exhibitions": 0,
  "Biotechnology": 0,
  "Marketing & Communications": 0,
  "Medical devices": 0,
  "Medical education": 0,
  "Pharmaceutical": 0,
  "Publishing": 0,
  "Teaching": 0
};

this.listview = false;

this.countries = [];

this.chosencountry = false;

this.chosensubject = false;

this.chosensector = false;

this.searchstring = "";

this.subjddtext = "Skill specialities";

this.sectddtext = "Business sector";

this.ctryddtext = "Country";

this.filtered = [];

this.initload = true;

this.on('mount', (function(_this) {
  return function() {
    _this.isadmin = _this.opts.isadmin || null;
    _this.userid = _this.opts.uid || null;
    api.get({
      isadmin: _this.isadmin
    }, function(data) {
      return _this.onload(data);
    });
    _this.update();
    return setTimeout(function() {
      return _this.initload = false;
    }, 5000);
  };
})(this));

this.searchtext = (function(_this) {
  return function(text) {
    return console.log(_this.artistsearchtext.value);
  };
})(this);

this.contains = function(target, pattern) {
  var val;
  val = 0;
  pattern.forEach(function(num) {
    val = val + target.includes(num);
  });
  return val === 1;
};

this.onload = (function(_this) {
  return function(data) {
    _this.artists = data.filter(function(artist) {
      var ba, now, sa;
      now = new Date();
      if (_this.moment(artist.renewal_date).isValid() && now > artist.renewal_date) {
        artist.expiry = _this.moment(artist.renewal_date).format('MMM YYYY');
      }
      artist.active = 0;
      if (artist.groups) {
        artist.groups.map(function(group) {
          if (group.id === 9) {
            return artist.active = 1;
          }
        });
      }
      if (artist.country && _this.countries.indexOf(artist.country) < 0) {
        _this.countries.push(artist.country);
      }
      artist.locale = artist.city || artist.state || false;
      sa = _this.checkJson(artist.subjectareas) || _this.subjopts;
      ba = _this.checkJson(artist.businessareas) || _this.busopts;
      artist.sastring = _this.setSpecialStrings(sa);
      artist.bustring = _this.setSpecialStrings(ba);
      artist.sashort = _this.shortString(sa);
      artist.bashort = _this.shortString(ba);
      if (_this.isadmin || artist.active) {
        return artist;
      }
    });
    _this.filtered = JSON.parse(JSON.stringify(_this.artists));
    _this.update();
    return setTimeout(function() {
      return $(document).ready(function() {
        return $('.owl-carousel').owlCarousel({
          items: 3,
          pagination: true,
          nav: true,
          margin: 15,
          navContainer: '#artists-nav',
          responsive: {
            0: {
              items: 1
            },
            992: {
              items: 3
            }
          }
        });
      });
    }, 1000);
  };
})(this);

this.showlistview = (function(_this) {
  return function() {
    _this.listview = true;
    return _this.update();
  };
})(this);

this.showgridview = (function(_this) {
  return function() {
    _this.listview = false;
    return _this.update();
  };
})(this);

this.checkJson = (function(_this) {
  return function(obj) {
    if (obj !== null && (obj.constructor !== {}.constructor)) {
      obj = JSON.parse(obj);
    }
    return obj;
  };
})(this);

this.setSpecialStrings = (function(_this) {
  return function(obj) {
    var str;
    str = '';
    Object.keys(obj).forEach(function(key) {
      if (obj[key] > 0) {
        return str += key + ", ";
      }
    });
    if (str.length > 0) {
      str = str.replace(/,(?=[^,]*$)/, '');
    }
    return str;
  };
})(this);

this.shortString = (function(_this) {
  return function(obj) {
    var newkeys, rndkey, str;
    str = '';
    newkeys = [];
    Object.keys(obj).forEach(function(key) {
      if (obj[key] > 0) {
        return newkeys.push(key);
      }
    });
    if (newkeys.length > 0) {
      rndkey = newkeys[newkeys.length * Math.random() << 0];
      str += rndkey;
      if (newkeys.length > 1) {
        str += ' <small><em>(+' + (newkeys.length - 1) + ' more)</em></small>';
      }
    }
    return str;
  };
})(this);

this.handlePage = (function(_this) {
  return function(page) {
    _this.page = page;
    _this.update();
    if (document.querySelector('.banner') && !_this.initload) {
      return document.querySelector('.banner').scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
})(this);

this.resetfilters = (function(_this) {
  return function() {
    _this.filtered = JSON.parse(JSON.stringify(_this.artists));
    _this.chosencountry = false;
    _this.chosensubject = false;
    _this.chosensector = false;
    _this.searchstring = "";
    _this.update();
    return _this.handlePage();
  };
})(this);

this.removeFilter = (function(_this) {
  return function(filt) {
    if (filt && ['country', 'sector', 'subject'].indexOf(filt) > -1) {
      if (filt === "country") {
        _this.chosencountry = false;
      }
      if (filt === "sector") {
        _this.chosensector = false;
      }
      if (filt === "subject") {
        _this.chosensubject = false;
      }
      return _this.filterartists(filt, false);
    }
  };
})(this);

this.filterartists = (function(_this) {
  return function(type, val) {
    if (val == null) {
      val = "";
    }
    _this.filtered = JSON.parse(JSON.stringify(_this.artists));
    if (type === "country") {
      _this.chosencountry = val || false;
      _this.ctryddtext = val || "Country";
    }
    if (type === "subject") {
      _this.chosensubject = val || false;
      _this.subjddtext = val || "Skill specialities";
    }
    if (type === "sector") {
      _this.chosensector = val || false;
      _this.sectddtext = val || "Business Sector";
    }
    if (type === "searchtext") {
      _this.searchstring = _this.artistsearchtext.value || "";
    }
    console.log(_this.chosencountry, _this.chosensubject, _this.chosensector, _this.searchstring, _this.filtered);
    if (_this.chosencountry) {
      _this.filtered = _this.filtered.map(function(artist) {
        if (_this.chosencountry === artist.country) {
          return artist;
        } else {
          return {};
        }
      });
      _this.filtered = _this.filtered.filter(function(value) {
        return Object.keys(value).length !== 0;
      });
    }
    if (_this.chosensubject) {
      _this.filtered = _this.filtered.map(function(artist) {
        if (artist.sastring.search(_this.chosensubject) > -1) {
          return artist;
        } else {
          return {};
        }
      });
      _this.filtered = _this.filtered.filter(function(value) {
        return Object.keys(value).length !== 0;
      });
    }
    if (_this.chosensector) {
      _this.filtered = _this.filtered.map(function(artist) {
        if (artist.bustring.search(_this.chosensector) > -1) {
          return artist;
        } else {
          return {};
        }
      });
      _this.filtered = _this.filtered.filter(function(value) {
        return Object.keys(value).length !== 0;
      });
    }
    if (_this.searchstring.length > 0) {
      _this.filtered = _this.filtered.map(function(artist) {
        var aname;
        aname = artist.first_name || "";
        aname = aname + " " + artist.surname || aname;
        aname = aname.toLowerCase();
        if (aname.search(_this.searchstring) > -1) {
          console.log(artist);
          return artist;
        } else {
          return {};
        }
      });
      _this.filtered = _this.filtered.filter(function(value) {
        return Object.keys(value).length !== 0;
      });
    }
    _this.update();
    return _this.handlePage();
  };
})(this);

/*

@filterartists = (type,val="")=>
  to = 0
  if type == "country"
    country = val || false
  else country = @chosencountry
  if type == "subject"
    subject = val || false
  else subject = @chosensubject
  if type == "sector"
    sector = val || false
  else sector = @chosensector
  if type == "searchtext"
    text = @artistsearchtext.value
    to = 200
  else text = ""

  if !@chosencountry && !@chosensector && !@chosensubject && @artistsearchtext.value.length <= 0
    @origartists = @artists

  setTimeout(=>
    @filtertext(@artistsearchtext.value)
    @filtercountry(country)
    @updatesubjects(subject)
    @updatesectors(sector)
    @update()
    @handlePage()
  ,to)

@filtertext = (text)=>
  if !@chosencountry && !@chosensector && !@chosensubject
    mapme = @artists
    console.log "text only"
  else
    mapme = @origartists
  console.log "search text",text
  if typeof(text) != "string"
    console.log "not string"
    @searchstring = ""
    @origartists = @origartists
  else
    console.log "is text!"
    @searchstring = text
    @origartists = mapme.map (artist)=>
      aname = artist.first_name || ""
      aname = aname + " " + artist.surname || aname
      aname = aname.toLowerCase()
      console.log aname.search(@searchstring)
      if aname.search(@searchstring) > -1
        console.log artist
        artist
      else {}
    console.log @origartists
    @origartists = @origartists.filter (value)=>
      Object.keys(value).length != 0
  #@update()

@filtercountry = (country)=>
  if @artistsearchtext.value.length <= 0 && !@chosensector && !@chosensubject
    mapme = @artists
    console.log "country only"
  else
    mapme = @origartists
  if typeof(country) != "string"
    @chosencountry = false
    #@origartists = @origartists
  else
    @chosencountry = country
    @origartists = mapme.map (artist)=>
      if artist.country == @chosencountry
        artist
      else {}
    @origartists = @origartists.filter (value)=>
      Object.keys(value).length != 0
  #@update()
  #@handlePage()
  #document.querySelector('.artist-filters').scrollIntoView({behavior:'smooth'})

@updatesubjects = (subject)=>
  if @artistsearchtext.value.length <= 0 && !@chosensector && !@chosencountry
    mapme = @artists
    console.log "subjects only"
  else
    mapme = @origartists
  if !subject
    @subjddtext = "Skill specilalities"
    @chosensubject = false
  else
    @subjddtext = subject
    @chosensubject = subject
    @origartists = mapme.map (artist)=>
      if artist.sastring.search(@chosensubject) > -1
        artist
      else {}
  @origartists = @origartists.filter (value)=>
    Object.keys(value).length != 0
  #@update()
  #@handlePage()

@updatesectors = (sector)=>
  if @artistsearchtext.value.length <= 0 && !@chosencountry && !@chosensubject
    mapme = @artists
    console.log "sectors only"
  else
    mapme = @origartists
  if !sector
    @sectddtext = "Skill specilalities"
    @chosensector = false
  else
    @sectddtext = sector
    @chosensector = sector
    @origartists = mapme.map (artist)=>
      if artist.bustring.search(@chosensector) > -1
        artist
      else {}
  @origartists = @origartists.filter (value)=>
    Object.keys(value).length != 0
  #@update()
  #@handlePage()

 * sort artists by field
@sortAZ = (a,b)=>
  namea = a.first_name
  nameb = b.first_name
  comparison = 0
  if namea > nameb
    comparison = 1
  else if namea < nameb
    comparison = -1
 */
});
    
  